import tenantConstants from '@constants';
import Cookies from 'js-cookie';
import { cookieDomain } from './env';

export const removeCookies = () => {
  Cookies.remove(tenantConstants.AUTH_TOKEN_COOKIE_KEY, cookieDomain && { domain: cookieDomain, path: '/' });
  window.location.href = tenantConstants.GET_LOGIN_PATH(window?.location?.href);
};
